import React, { useEffect, useState } from 'react';
import { Card, Button, Space, Typography, Divider } from 'antd';

const { Title, Text, Paragraph } = Typography;

interface DebugInfo {
  token_new: string | null;
  token_old: string | null;
  user_new: string | null;
  user_old: string | null;
  userObj_new: any;
  userObj_old: any;
  tokenParts_new: string[] | null;
  tokenParts_old: string[] | null;
}

const TokenDebugPage: React.FC = () => {
  const [debugInfo, setDebugInfo] = useState<DebugInfo>({
    token_new: null,
    token_old: null,
    user_new: null,
    user_old: null,
    userObj_new: null,
    userObj_old: null,
    tokenParts_new: null,
    tokenParts_old: null
  });

  useEffect(() => {
    const gatherDebugInfo = () => {
      const info: DebugInfo = {
        // Lấy token từ các key khác nhau
        token_new: localStorage.getItem('quanly_truonghoc_token'),
        token_old: localStorage.getItem('token'),
        user_new: localStorage.getItem('quanly_truonghoc_user'),
        user_old: localStorage.getItem('userInfo'),
        // Parse user info
        userObj_new: null,
        userObj_old: null,
        // Token structure check
        tokenParts_new: null,
        tokenParts_old: null
      };

      try {
        if (info.user_new) {
          info.userObj_new = JSON.parse(info.user_new);
        }
      } catch (e) {
        info.userObj_new = { error: 'Invalid JSON' };
      }

      try {
        if (info.user_old) {
          info.userObj_old = JSON.parse(info.user_old);
        }
      } catch (e) {
        info.userObj_old = { error: 'Invalid JSON' };
      }

      // Check token structure
      if (info.token_new) {
        info.tokenParts_new = info.token_new.split('.');
      }
      if (info.token_old) {
        info.tokenParts_old = info.token_old.split('.');
      }

      setDebugInfo(info);
    };

    gatherDebugInfo();
  }, []);

  const clearAllStorage = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.reload();
  };

  const testAPI = async () => {
    const token = localStorage.getItem('quanly_truonghoc_token') || localStorage.getItem('token');
    
    try {
      const response = await fetch('/api/v1/statistic/teaching-hours-by-teacher?mode=year&year=2024', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      const result = await response.json();
      console.log('API Test Result:', result);
      alert(`API Response: ${JSON.stringify(result, null, 2)}`);
    } catch (error) {
      console.error('API Test Error:', error);
      alert(`API Error: ${error}`);
    }
  };

  return (
    <div style={{ padding: '24px' }}>
      <Title level={2}>🔍 Token Debug Information</Title>
      
      <Card title="🔑 Token Information" style={{ marginBottom: '16px' }}>
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
          <div>
            <Text strong>New Token (quanly_truonghoc_token):</Text>
            <Paragraph code copyable ellipsis={{ rows: 2 }}>
              {debugInfo.token_new || 'Không có'}
            </Paragraph>
            {debugInfo.tokenParts_new && (
              <Text type="secondary">
                Có {debugInfo.tokenParts_new.length} phần (JWT cần 3 phần)
              </Text>
            )}
          </div>
          
          <div>
            <Text strong>Old Token (token):</Text>
            <Paragraph code copyable ellipsis={{ rows: 2 }}>
              {debugInfo.token_old || 'Không có'}
            </Paragraph>
            {debugInfo.tokenParts_old && (
              <Text type="secondary">
                Có {debugInfo.tokenParts_old.length} phần (JWT cần 3 phần)
              </Text>
            )}
          </div>
        </Space>
      </Card>

      <Card title="👤 User Information" style={{ marginBottom: '16px' }}>
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
          <div>
            <Text strong>New User Info (quanly_truonghoc_user):</Text>
            <Paragraph code>
              {JSON.stringify(debugInfo.userObj_new, null, 2)}
            </Paragraph>
          </div>
          
          <div>
            <Text strong>Old User Info (userInfo):</Text>
            <Paragraph code>
              {JSON.stringify(debugInfo.userObj_old, null, 2)}
            </Paragraph>
          </div>
        </Space>
      </Card>

      <Divider />

      <Space>
        <Button type="primary" onClick={testAPI}>
          🧪 Test API
        </Button>
        <Button type="default" danger onClick={clearAllStorage}>
          🧹 Clear All Storage & Reload
        </Button>
      </Space>
    </div>
  );
};

export default TokenDebugPage;
